import { Quote } from '@britishcouncil/react-solas-ors3';

export const PaymentNotAvailableMsg = () => (
  <Quote title="" intent="danger">
    <p>Method payments are not availble in your country/territory. Please, contact with British Council Office.</p>
  </Quote>
);
